import React, { useMemo } from 'react'
import WebinarSidebarSeparator from '../../../sharedLegacy/features/WebinarSidebarFeature/components/WebinarSidebarSeparator/WebinarSidebarSeparator'
import useFeatures from '../../../sharedLegacy/hooks/useFeatures'
import { useSelectedChatId } from '../../blocs/chatVisibility'
import { ChatForm } from '../ChatForm/ChatForm'
import { ChatMessages } from '../ChatMessages/ChatMessages'
import { useIsLocalGuestSpeaker } from '../../../Speakers/blocs/useSpeakers'
import { Reply } from '../Reply/Reply'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'
import { getRole } from '../../../global/blocs/roomInfo'

import './Chat.scss'

const Chat = () => {
  const { HasSpeakerChatEnabled } = useFeatures()
  const isLocalGuestSpeaker = useIsLocalGuestSpeaker()
  const { data: liveData } = useLiveDataQuery()
  const selectedChatId = useSelectedChatId()

  const showChatForm = useMemo(() => {
    if (selectedChatId === 'speaker-chat') return true

    const commentMode = liveData?.comment_mode
    if (!commentMode || commentMode === 'none') return false

    return commentMode === 'all' || getRole() !== 'audience'
  }, [liveData?.comment_mode, selectedChatId])

  return (
    // styled as flex column-reverse for accessibility reasons
    <div className="webinar-chat">
      {showChatForm && (
        <>
          <ChatForm />
          <Reply />
          <WebinarSidebarSeparator />
        </>
      )}

      {!isLocalGuestSpeaker && HasSpeakerChatEnabled && (
        <ChatMessages type="speaker-chat" />
      )}

      <ChatMessages type="chat" />
    </div>
  )
}

export { Chat }
